module.exports = __webpack_public_path__ + "img/emplois-sante.f2e4b930.svg";